import { store } from '../../../../../store/store';
import { AngularServices, getAngularService } from '../../../../core';
import { setSelfPreviewLoading } from '../../../actions';
import { selectInstitution } from '../../../../../store/features/system';
export class NoVideoSourceError extends Error {
    constructor() {
        super('No video source');
    }
}
export function getCallPublisher() {
    const vpFactory = getAngularService(AngularServices.VideoProviderFactory);
    return vpFactory.activeProvider.getPublisher();
}
async function applyEffect({ filter }, publisher) {
    return filter
        ? publisher.applyVideoFilter(filter)
        : publisher.clearVideoFilter();
}
export const applyPublisherEffect = (() => {
    let isApplying = false;
    let next = null;
    return async (effect, publisher = getCallPublisher()) => {
        if (isApplying) {
            next = effect;
            return;
        }
        isApplying = true;
        store.dispatch(setSelfPreviewLoading(true));
        await applyEffect(effect, publisher).finally(() => {
            store.dispatch(setSelfPreviewLoading(false));
            isApplying = false;
        });
        if (next) {
            const nextEffect = next;
            next = null;
            void applyPublisherEffect(nextEffect, publisher);
        }
    };
})();
/**
 * Returns `true` if the current institution's `logoHorizontal` is the default value.
 */
export const getIsLogoHorizontalDefault = () => {
    const currentInstitution = selectInstitution(store.getState());
    /**
     * The 2nd value is the default value for the `logoHorizontal` field.
     * however when removing the logo from the institution, the value can be set to an empty string.
     */
    const logoHorizontal = currentInstitution?.logoHorizontal;
    const defaultLogoHorizontalValues = [
        '',
        '/assets/icons/legacy/logo-horizontal-black.png',
    ];
    const isDefault = defaultLogoHorizontalValues.includes(logoHorizontal);
    return isDefault;
};
